import { Typography, Button } from "@material-ui/core";
import React, { Component } from "react";
import Lottie from "react-lottie";
import success from "../Assets/lottie/lf30_editor_rxhvowbd.json";
import tick from "../Assets/Images/tick_circle.png";
import Modal from "react-awesome-modal";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../Constants/APIs";
class PaymentSucces extends Component {
  state = {
    isStopped: true,
    showTick: true,
    openModal: true.valueOf,
    userFirstName: "",
    userLastName: "",
    item: "",
    price: "",
  };
  componentDidMount() {
    // console.log(window.location.href);
    let authToken = localStorage.getItem("token");
    var url_string = window.location.href; //window.location.href
    var url = new URL(url_string);
    var payId = url.searchParams.get("id");
    // console.log(payId);
    const payload = {
      page_id: payId,
    };
    // console.log(payload);
    axios
      .post(API.postUrls.order, payload, {
        headers: { Authorization: "Bearer " + authToken },
      })
      .then((resp) => {
        // console.log(resp.data);
        if (resp.data.status === "success") {
          this.setState({
            userFirstName:
              resp.data.data.order_summary.content.customer.first_name,
            userLastName:
              resp.data.data.order_summary.content.customer.last_name,
            item: resp.data.data.order_summary.content.subscription
              .subscription_items[0].item_price_id,
            price:
              resp.data.data.order_summary.content.subscription
                .subscription_items[0].amount,
            showTick: true,
            isStopped: false,
          });
        }
      });
  }

  render() {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: success,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
    return (
      <div className="Lottiewrapper">
        {
          this.state.showTick ? (
            <img src={tick} width="200px" height="200px" alt="" />
          ) : null
          // <Lottie
          //   options={defaultOptions}
          //   height={300}
          //   width={300}
          //   isStopped={this.state.isStopped}
          // />
        }
        <Typography variant={"h5"} className="typo">
          {" "}
          Hello{" "}
          <span style={{ textTransform: "capitalize" }}>
            {this.state.userFirstName}
          </span>{" "}
          {this.state.userLastName}, You have successfully purchased{" "}
          {this.state.item} plan of amount Rs.{this.state.price}.{" "}
          {/* Hello Shivani Game, You have successfully purchased Beginner-USD-Monthly plan of amount Rs.299. */}
        </Typography>

        <Link to="/productlist/allProducts" style={{ textDecoration: "none" }}>
          <Button
            size={"large"}
            variant="contained"
            className="themeBtnSuccess txtShadow rounded"
          >
            Go To Dashboard
          </Button>
        </Link>

        {/* <Modal
          visible={this.state.openModal}
          width="400"
          height="300"
          effect="fadeInUp"
          onClickAway={() => this.setState({ openModal: false })}
        >
          <div className="confirmationModal" style={{ textAlign: "center" }}>
            <Typography>
              Hello User, You have successfully purchased Beginner Plan.
            </Typography>
            
            <Button
              onClick={() => this.setState({ openModal: false })}
              className="DeleteBtn"
              style={{ background: "#bdbdbd", border: "none", marginTop: "50px" }}
            >
              Close
            </Button>
            <p style={{ color: "green", textTransform: "capitalize" }}>
              {this.state.notification ? this.state.successMsg : ""}{" "}
            </p>
          </div>
        </Modal> */}
      </div>
    );
  }
}

export default PaymentSucces;
